// August typography v2 prompt-length rule: short prompts (<=12 words) render as the
// handwritten note (Signatural); longer prompts render as reading content (Inter).
export const isHandwrittenLength = (text, maxWords = 12) =>
  !!text && text.trim().split(/\s+/).filter(Boolean).length <= maxWords
